import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { FixStreaksResponse } from './types';

type FixMemberStreaksParams = {
  memberId: string;
  dates: string[];
};

export async function fixMemberStreaks({ memberId, dates }: FixMemberStreaksParams) {
  const url = `/web/studio/users/${memberId}/streaks/fix`;

  const response = await api.executePostRequest<ObjectResponse<FixStreaksResponse>>(url, { dates });

  return response.data;
}
